import { cacheFirstConfig, http } from '@/core/helpers/axiosHelper';

export class TrialPeriodService {
   async getTrialPeriods() {
      return http.get('/trial-periods', cacheFirstConfig).then((response: any) => {
         return response.data.data;
      });
   }
}
